// extracted by mini-css-extract-plugin
export var background = "styles-module--background--5654a";
export var content = "styles-module--content--3cea4";
export var description = "styles-module--description--d0ed0";
export var desktop = "styles-module--desktop--c129c";
export var details = "styles-module--details--87336";
export var phone = "styles-module--phone--ef377";
export var tablet = "styles-module--tablet--2ab64";
export var title = "styles-module--title--0e930";
export var wrapper = "styles-module--wrapper--bf3e7";